import type { BlockT } from "@patient-watch/types";

/** FlowOx Device Training video block. */
export const FLOWOX_TRAINING_VIDEO_BLOCK_ID = "f10f7e61-6d13-4bfc-9a5c-3f6d913f9f13";
/** Prescription Upload info text block. */
export const PRESCRIPTION_BODY_BLOCK_ID = "e8f9a0b1-2c3d-4000-8003-000000000001";

const BLOCK_COPY: Record<
    string,
    Partial<Record<"de-DE" | "da-DK", { caption?: string; content?: string; media_url?: string }>>
> = {
    [FLOWOX_TRAINING_VIDEO_BLOCK_ID]: {
        "de-DE": {
            caption: "FlowOx™-Geräteschulungsvideo",
            media_url: "https://youtu.be/j-63bstEFJE",
        },
        "da-DK": { caption: "FlowOx-enhedstræningsvideo" },
    },
    [PRESCRIPTION_BODY_BLOCK_ID]: {
        "de-DE": {
            content: "Wenn Sie noch keine Verordnung haben, können Sie ohne Upload fortfahren.",
        },
        "da-DK": {
            content: "Hvis du endnu ikke har din recept, så log ud og kom tilbage, når du har den.",
        },
    },
};

/** Overlay known block caption/content for de-DE and da-DK. Canonical English stays on the row. */
export function localizeBlock(block: BlockT, locale: string): BlockT {
    if (locale !== "de-DE" && locale !== "da-DK") {
        return block;
    }

    const copy = BLOCK_COPY[block.block_id]?.[locale];
    if (!copy) {
        return block;
    }

    return {
        ...block,
        ...(copy.caption != null ? { caption: copy.caption } : {}),
        ...(copy.content != null ? { content: copy.content } : {}),
        ...(copy.media_url != null ? { media_url: copy.media_url } : {}),
    };
}
